/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userApi from 'api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';

/* Thunks */
export const acceptInvitation = createFOAsyncThunk('handleInvitation/acceptInvitation', async (args) => {
  return userApi.acceptInvitation(args.invitationId);
});

export const declineInvitation = createFOAsyncThunk('handleInvitation/declineInvitation', async (args) => {
  return userApi.declineInvitation(args.invitationId);
});
